<template>
    <layout :studio="studio" :cart="cart">
        <div class="shop-home">
            <el-carousel :autoplay="true" :interval="8000" :loop="true" trigger="click" :arrow="studio.slides.length > 1 ? 'hover' : 'never'" indicator-position="none">
                <template v-if="studio.slides.length > 0">
                    <el-carousel-item v-for="slide in studio.slides" :key="`slide-${slide.id}`">
                        <responsive-image :media="slide.photo" :title="slide.title || ''" type="" size="1440px" width="1440px" class="mx-auto"></responsive-image>
                    </el-carousel-item>
                </template>
                <template v-else>
                    <el-carousel-item>
                        <img
                            :src="asset('shop/to-gogh-kits.jpg')"
                            alt="Brush Crazy Shop"
                            title="Brush Crazy Shop"
                            loading="lazy"
                            width="1440px"
                            class="mx-auto max-h-128 object-scale-down"
                        />
                    </el-carousel-item>
                </template>
            </el-carousel>
            <div class="items-center justify-between lg:flex lg:space-x-4">
                <div class="my-4 flex-1 rounded-lg bg-white p-4 shadow-md">
                    <a :href="route('studio.shop.browse', { studioSlug: studio.slug, category: 1 })" title="Canvases">
                        <img :src="asset('shop/boxes/canvas.jpg')" alt="Canvases" title="Canvases" loading="lazy" width="300px" class="mx-auto object-scale-down" />
                    </a>
                </div>
                <div class="my-4 flex-1 rounded-lg bg-white p-4 shadow-md">
                    <a :href="route('studio.shop.browse', { studioSlug: studio.slug, category: 2 })" title="Ceramics">
                        <img :src="asset('shop/boxes/ceramic.jpg')" alt="Ceramics" title="Ceramics" loading="lazy" width="300px" class="mx-auto object-scale-down" />
                    </a>
                </div>
                <div class="my-4 flex-1 rounded-lg bg-white p-4 shadow-md">
                    <a :href="route('studio.shop.browse', { studioSlug: studio.slug, category: 44 })" title="Glass">
                        <img :src="asset('shop/boxes/glass.jpg')" alt="Glass" title="Glass" loading="lazy" width="300px" class="mx-auto object-scale-down" />
                    </a>
                </div>
            </div>
            <div class="items-center justify-between lg:flex lg:space-x-4">
                <div class="my-4 flex-1 rounded-lg bg-white p-4 shadow-md">
                    <a :href="route('studio.shop.browse', { studioSlug: studio.slug, category: 46 })" title="3D Wood Signs">
                        <img :src="asset('shop/boxes/3d-wood.jpg')" alt="3D Wood Signs" title="3D Wood Signs" loading="lazy" width="440px" class="mx-auto object-scale-down" />
                    </a>
                </div>
                <div class="my-4 flex-1 rounded-lg bg-white p-4 shadow-md">
                    <a :href="route('studio.shop.browse', { studioSlug: studio.slug, category: 39 })" title="Chainsaw Wood">
                        <img :src="asset('shop/boxes/chainsaw.jpg')" alt="Chainsaw Wood" title="Chainsaw Wood" loading="lazy" width="440px" class="mx-auto object-scale-down" />
                    </a>
                </div>
            </div>
            <div class="items-center justify-between lg:flex lg:space-x-4">
                <div class="my-4 flex-1 rounded-lg bg-white p-4 shadow-md">
                    <a :href="route('studio.shop.browse', { studioSlug: studio.slug, category: 37 })" title="Wood Pallet Signs">
                        <img
                            :src="asset('shop/boxes/wood-pallet.jpg')"
                            alt="Wood Pallet Signs"
                            title="Wood Pallet Signs"
                            loading="lazy"
                            width="440px"
                            class="mx-auto object-scale-down"
                        />
                    </a>
                </div>
                <div class="my-4 flex-1 rounded-lg bg-white p-4 shadow-md">
                    <a :href="route('studio.shop.browse', { studioSlug: studio.slug, category: 25 })" title="Wood Cutouts">
                        <img :src="asset('shop/boxes/wood-cutout.jpg')" alt="Wood Cutouts" title="Wood Cutouts" loading="lazy" width="440px" class="mx-auto object-scale-down" />
                    </a>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
    import hasCart from '@/mixins/hasCart';
    import Layout from '@/frontend/components/Studio/Shop/Layout.vue';
    import ResponsiveImage from '@/components/ResponsiveImage.vue';

    export default {
        name: 'Shop',
        components: {
            Layout,
            ResponsiveImage,
        },
        filters: {},
        mixins: [hasCart],
        props: {
            studio: {
                required: true,
                type: Object,
            },
            entity: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {};
        },
    };
</script>

<style>
    .shop-home .el-carousel__container {
        height: 12vh;
    }

    @media (min-width: 768px) {
        .shop-home .el-carousel__container {
            height: 22vh;
        }
    }

    @media (min-width: 1024px) {
        .shop-home .el-carousel__container {
            height: 28vh;
        }
    }

    @media (min-width: 1280px) {
        .shop-home .el-carousel__container {
            height: 36vh;
        }
    }

    @media (min-width: 1920px) {
        .shop-home .el-carousel__container {
            height: 24vh;
        }
    }

    @media (min-width: 2560px) {
        .shop-home .el-carousel__container {
            height: 18vh;
        }
    }
</style>
